import axios from "axios";

// API Service - Centralized API calls to hide endpoints from main component
class ApiService {
  constructor() {
    // Use environment variables
    this.baseURL = process.env.REACT_APP_API_BASE_URL || "https://rishtey.rishteymatch.in";
    this.apiEndpoint = process.env.REACT_APP_API_ENDPOINT || "https://rishtey.rishteymatch.in/api2";
  }

  // Login
  async login(email, password) {
    try {
      const response = await axios.post(`${this.apiEndpoint}/login`, {
        email,
        password,
      });
      return response.data;
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  }

  // Signup
  async signup(formData) {
    try {
      const response = await fetch(`${this.apiEndpoint}/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      return await response.json();
    } catch (error) {
      console.error("Signup error:", error);
      throw error;
    }
  }

  // Get user by ID
  async getUser(userId) {
    try {
      const response = await axios.get(`${this.apiEndpoint}/api/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Get user error:", error);
      throw error;
    }
  }

  // Logout
  async logout(token) {
    try {
      const response = await axios.post(
        `${this.apiEndpoint}/api/logout`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      console.error("Logout error:", error);
      throw error;
    }
  }

  // Get active users
  async getActiveUsers() {
    try {
      const response = await axios.get(`${this.apiEndpoint}/getActiveUsers`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  }

  // Send chat message
  async sendChat(fromUserId, toUserId, message) {
    try {
      const response = await axios.post(`${this.apiEndpoint}/api/send-chat`, {
        fromUserId,
        toUserId,
        message,
      });
      return response.data;
    } catch (error) {
      console.error("Error sending chat:", error);
      throw error;
    }
  }

  // Send like notification
  async sendLike(fromUserId, toUserId) {
    try {
      const response = await axios.post(`${this.apiEndpoint}/api/send-like`, {
        fromUserId,
        toUserId,
      });
      return response.data;
    } catch (error) {
      console.error("Error sending like:", error);
      throw error;
    }
  }

  // Get all users (for admin dashboard)
  async getAllUsers() {
    try {
      const response = await fetch(`${this.apiEndpoint}/getAllUsers`);
      return await response.json();
    } catch (error) {
      console.error("Error fetching all users:", error);
      throw error;
    }
  }

  // Delete user
  async deleteUser(id) {
    try {
      const response = await fetch(`${this.apiEndpoint}/api/delete-user/${id}`, { 
        method: "DELETE" 
      });
      return await response.json();
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  }

  // Update user status
  async updateUserStatus(id, status) {
    try {
      const response = await fetch(`${this.apiEndpoint}/api/user/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status }),
      });
      return await response.json();
    } catch (error) {
      console.error("Error updating user status:", error);
      throw error;
    }
  }

  // Update user permissions
  async updatePermission(id, field, value) {
    try {
      const response = await fetch(`${this.apiEndpoint}/updatePermission`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, field, value }),
      });
      return await response.json();
    } catch (error) {
      console.error("Error updating permission:", error);
      throw error;
    }
  }

  // Update user
  async updateUser(id, formData) {
    try {
      const response = await fetch(`${this.apiEndpoint}/api/user/${id}`, {
        method: "PUT",
        body: formData,
      });
      return await response.json();
    } catch (error) {
      console.error("Error updating user:", error);
      throw error;
    }
  }

  // Register step
  async registerStep(formData) {
    try {
      const response = await fetch(`${this.apiEndpoint}/register-step`, {
        method: 'POST',
        body: formData,
      });
      return await response.json();
    } catch (error) {
      console.error("Register step error:", error);
      throw error;
    }
  }

  // Get notifications
  async getNotifications(userId) {
    try {
      const response = await axios.get(`${this.apiEndpoint}/api/notifications/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching notifications:", error);
      throw error;
    }
  }

  // Get image URL
  getImageUrl(imagePath) {
    if (!imagePath) return null;
    if (imagePath.startsWith("http")) return imagePath;
    if (imagePath.startsWith("/")) return `${this.baseURL}${imagePath}`;
    return `${this.baseURL}/${imagePath}`;
  }

  // Get API endpoint
  getApiEndpoint() {
    return this.apiEndpoint;
  }

  // Get base URL
  getBaseUrl() {
    return this.baseURL;
  }
}

export default new ApiService();
